module.exports = __webpack_public_path__ + "static/policy_change-8f921786ac119743ce8fb6d0f096a016.png";